import * as React from 'react';
import HistoryCharts from '../History/HistoryCharts';
import HistoryCar from '../History/HistoryCar';
import CollisionTimeLine from '../History/CollisionTimeLine/CollisionTimeLine';
import { withTranslation  } from 'react-i18next';
import { connect } from 'react-redux';
import {getCollisionDataframes} from 'Redux/Actions/CollisionActions'
import CollisionMap from './CollisionMap'


export class HistoryCollision extends React.Component {
  public render() {
    return (
      <div className="userManagement--noPadding HistoryCollision">
        <div>
          <HistoryCharts />
          <HistoryCar />
        </div>
        <CollisionMap />
        <CollisionTimeLine />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/History/HistoryCollision.tsx